import { Component, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { AbiertasService } from 'app/main/wizard-cgo/services/abiertas.service';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { BroadcastTranslate } from './broadcasttranslate.service';
import { BroadcastPreview } from './broadcastpreview.service';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'app-abiertas',
  templateUrl: './abiertas.component.html',
  styleUrls: ['./abiertas.component.scss']
})
export class AbiertasComponent implements OnInit {

  productoCertificar: backInter.prodGenerico;
  pasoCompleto=false;
  cargando= false;
  numArrayTraduc: number = 0;

  userData:any;
  validationUser:boolean=false;
  desbloqueoEstatus:boolean=false;

  constructor(
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private broadcastTranslate: BroadcastTranslate,
    private broadcastPreview: BroadcastPreview,
    private abiertasService: AbiertasService,
    private _snackBar: MatSnackBar,
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
    }
    else{
      this.validationUser=false;
    }
    }

  }
  instituto:any;
  ngOnInit() {
    this.obtieneCertificarActual();
    this.obtieneInstituto();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituo "+this.instituto);
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.abiertasService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodGenerico[] = data.productosMedir2;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaProducto;
            let idProducto = producto.idProducto;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.getEstatusDesbloqueo();
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.abiertasService.getStatusAbiertasMedirGenerico(localStorage.getItem('productoID')).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      },error=>{
        console.log(error);
      });

      this.getStatusModal();
      this.getNumTraducciones();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      //console.log("error al recuperar certificar vigente");
    });
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idProducto).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idProducto,
      demograficos: 1
    };
    console.log(datos);
    this.wizardService.getStatusModalMedir(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('ABIERTAS');
      }
    },error=>{
      console.log(error);
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idProducto,
      demograficos: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModalMedir(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getNumTraducciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.abiertasService.getTraducciones(data).subscribe(response => {
      if(response['message'] == 'Success'){
        this.numArrayTraduc = response['arrayMostrar'].length;
      }
    }, error => {
      console.log("error", error);
    });
  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  desbloquearAbiertas(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          this.abiertasService.DesbloquearPasoAbiertasMedir(this.productoCertificar.idProducto).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '219'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          console.log("entro para completar padso");
          this.abiertasService.guardaStatusAbiertasMedirGenerico(this.productoCertificar.idProducto).subscribe( (data: backInter.RespuestaGen) => {
            console.log(data);
            this.aletaRestric('ABIERTAS.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();

            /*if(data.message == '219'){
              this.aletaRestric('ABIERTAS.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };*/
          },error=>{
            console.log(error);
          });
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        this.openSnackBar(texto,"OK");
        /*Swal.fire({
          icon: 'success',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });*/
      }
    }

  }

  completarPaso(){
    this.ValidarTraducciones();
    /*if(this.pasoCompleto){
      this.aletaRestric('ABIERTAS.COMPLETADO',null,'warning');
    }*/
    /*else{
      // if(this.preguntasAdicionales.adicionalesMostrar.length > 0 || this.sinAdicionales){
        this.aletaRestric('ABIERTAS.COMPLETAR',true);
      // }
      // else{
      //   this.aletaRestric('ADICIONALES.NADA',null,'warning');
      // }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }*/
  }

  sendBroadcast(indexTab){
    indexTab = indexTab['index'];
    console.log(indexTab);
    if(indexTab == 1){
      // send product data to subscribers via observable subject
      this.broadcastTranslate.sendEvent();
    }else if(indexTab == 2){
      // send product data to subscribers via observable subject
      this.broadcastPreview.sendEvent();
    }
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }


  arraytraducciones: backInter.traduccionesAbiertas[];
  arrayReactivo: backInter.reactivoabiertasTraduccion[];
  arrayValidacion=0;
  arrayReactivo_second: backInter.reactivoabiertasTraduccion[];
  arrayValidacionSecond=0;
  validacionIdioma=0;
  public ValidarTraducciones(){
    let texto = 'MODALES.VALIDACION.ERROR1';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.abiertasService.getTraducciones(data)
    .subscribe( (response:backInter.respuestaAbiertasTraducciones) => {
      if(response['message'] == 'Success'){
       //response.arrayMostrar;
       console.log(response);
       this.arraytraducciones = response.arrayMostrar;
       if(this.arraytraducciones.length > 0){
        for(let i = 0; i<this.arraytraducciones.length; i++){
          this.arrayReactivo=this.arraytraducciones[i].abiertas;
          for(let j=0; j < this.arrayReactivo.length; j++){
            if(this.arrayReactivo[j].preguntaTraduccion.length > 0){
              this.arrayValidacion++;
            }
          }// Fin segundo for
          if(this.arrayReactivo.length == this.arrayValidacion){
            console.log("Correcto pos "+i);
            this.arrayValidacion=0;
            this.validacionIdioma++;
          }else{
            this.arrayValidacion=0;
          }
        }// Fin primer for
        if(this.validacionIdioma == this.arraytraducciones.length){
          this.validacionIdioma=0;
          this.aletaRestric('REACTIVOS.COMPLETAR',true);
        }else{
          this.validacionIdioma=0;
          Swal.fire(
            ''+texto,
            '',
            'warning'
          );
        }

       }else{// segunda parte
        if(this.pasoCompleto){
          this.aletaRestric('ABIERTAS.COMPLETADO',null,'warning');
        }
        else{
            this.aletaRestric('ABIERTAS.COMPLETAR',true);
        }

       }

       /*if(this.arraytraducciones.length > 0){
        this.arrayReactivo=this.arraytraducciones[0].abiertas;
        for(let i=0; i < this.arrayReactivo.length;i++){
           if(this.arrayReactivo[i].preguntaTraduccion.length > 0){
             this.arrayValidacion++;
           }
        }

        console.log("Tamanio reactivo "+this.arrayReactivo.length);
        console.log("Bandera "+this.arrayValidacion);
        if(this.arrayReactivo.length == this.arrayValidacion){
           this.arrayValidacion=0;
           console.log("Todo correcto primero");
          if(this.arraytraducciones.length > 1){
            this.arrayReactivo_second=this.arraytraducciones[1].abiertas;
            for(let i=0; i < this.arrayReactivo_second.length;i++){
              if(this.arrayReactivo_second[i].preguntaTraduccion.length > 0){
                this.arrayValidacionSecond++;
              }
            }
            console.log("Bandera 2 "+this.arrayValidacionSecond);
            if(this.arrayReactivo_second.length == this.arrayValidacionSecond){
              if(this.pasoCompleto){
                this.aletaRestric('REACTIVOS.COMPLETADO',null,'warning');
              }
              else{
                this.aletaRestric('REACTIVOS.COMPLETAR',true);
              }
            }else{ // No están completas
              this.arrayValidacion=0;
              this.arrayValidacionSecond=0;
              Swal.fire(
                ''+texto,
                '',
                'warning'
              );
            }
          }else{
            this.aletaRestric('REACTIVOS.COMPLETAR',true);
            //this.aletaRestric('ABIERTAS.COMPLETADO',null,'warning');
          }
       }else{
        this.arrayValidacion=0;
        this.arrayValidacionSecond=0;
         console.log("TODO INCORRECTO");
         Swal.fire(
           ''+texto,
           '',
           'warning'
         );
       }

       }else{// segunda parte
        if(this.pasoCompleto){
          this.aletaRestric('ABIERTAS.COMPLETADO',null,'warning');
        }
        else{
            this.aletaRestric('ABIERTAS.COMPLETAR',true);
        }

       } */
        this.arrayValidacion=0;
        this.arrayValidacionSecond=0;
      }
    }, error => {
      console.log("error", error);
    });
  }

}
